<template>
  <div class="container-fluid">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LandTitleLayout'
}
</script>

<style scoped>
</style>
